"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../_form/constants");
var _helperComponents = require("../_form/helperComponents");
var _utils = require("../utils");
var _constants2 = require("./constants");
var _helperComponents2 = require("./helperComponents");
var _propTypes = require("./propTypes");
var _react2 = require("@emotion/react");
const Input = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    flex,
    insetElementLeading,
    insetElementTrailing,
    margin,
    maxWidth,
    minWidth,
    width,
    ...inputProps
  } = _ref;
  const containerProps = {
    flex,
    // this does not make sense without forwarding `display` prop too, since PositionRelativeContainer has display="inline-block"
    margin,
    maxWidth,
    minWidth,
    width
  };
  const {
    disabled
  } = inputProps;
  const leadingConfig = insetElementLeading ? {
    ..._constants2.INSET_ELEMENT_DEFAULTS,
    ...insetElementLeading
  } : undefined;
  const trailingConfig = insetElementTrailing ? {
    ..._constants2.INSET_ELEMENT_DEFAULTS,
    ...insetElementTrailing
  } : undefined;
  const disabledOffset = disabled ? _constants2.DISABLED_ICON_OFFSET : 0;
  const padding = {
    left: leadingConfig ? leadingConfig.width + leadingConfig.inset * 2 + disabledOffset :
    // There is an edge case where if *only* trailingConfig is passed, it overrides
    // styles for disabled icon. Passing the default value here makes the override not happen
    _constants.INPUT_PADDING_HORIZONTAL_DEFAULT + disabledOffset,
    right: trailingConfig ? trailingConfig.width + trailingConfig.inset * 2 : undefined
  };
  return (0, _react2.jsx)(_helperComponents.PositionRelativeContainer, containerProps, !!disabled && (0, _react2.jsx)(_helperComponents.FormDisabledIcon, {
    "aria-hidden": true
  }), leadingConfig && (0, _react2.jsx)(_helperComponents2.InsetElementContainer, {
    disabled: disabled,
    inset: leadingConfig.inset
  }, leadingConfig.element), (0, _react2.jsx)(_helperComponents2.InputBase, (0, _extends2.default)({
    padding: padding,
    width: "100%"
  }, inputProps, {
    ref: ref
  })), trailingConfig && (0, _react2.jsx)(_helperComponents2.InsetElementContainer, {
    inset: trailingConfig.inset,
    isTrailing: true
  }, trailingConfig.element));
});
var _default = exports.default = (0, _utils.composeStencilComponent)({
  baseComponent: Input,
  defaultProps: _constants2.inputDefaultProps,
  description: 'Form element that accepts text based inputs.',
  displayName: 'Input',
  propTypes: _propTypes.inputPropTypes
});